// extracted by mini-css-extract-plugin
module.exports = {"subContainer1":"ChatDropdown_subContainer1__W1Ywn","label":"ChatDropdown_label__1V9YG","changeDiv":"ChatDropdown_changeDiv__1SyNN","addBlurr":"ChatDropdown_addBlurr__2CbhS"};